if (!process.env.REACT_APP_API_URL) {
  throw new Error("Falta REACT_APP_API_URL en el .env");
}

const API_HOST = process.env.REACT_APP_API_URL;

// Constantes de headers HTTP (SonarQube: evitar literales duplicados)
export const HEADERS_JSON = { "Content-Type": "application/json" };
export const METHOD_POST  = "POST";
export const METHOD_PUT   = "PUT";
export const METHOD_GET   = "GET";
export const XHR_HEADER   = { "X-Requested-With": "XMLHttpRequest" };

export default API_HOST;